import { render, staticRenderFns } from "./AssignToken.vue?vue&type=template&id=4e15ea69"
import script from "./AssignToken.vue?vue&type=script&lang=js"
export * from "./AssignToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports